module.exports = __webpack_public_path__ + "static/media/Hair_3_blue.66abebdf.svg";